"use strict";

function ProductSelectionRenderHelper(deps) {
    var utils = deps.utils;
    var sdk = deps.sdk;
    var getConfig = deps.config.getConfig;

    //DOM nodes
    var rootTarget = deps.rootTarget;
    var productSelectionTarget;

    // functions
    var triggerError;
    var renderCalendarEvents;

    var timumFetchProducts = function () {
        utils.doCallback("timumFetchProductsStarted", getConfig());

        var promise = sdk.getProducts();

        return promise
            .then(function (response) {
                utils.doCallback("timumFetchProductsSuccessfull", getConfig(), response);
                getConfig().products = response.data.products;

                if (getConfig().products.length > 1) {
                    showProductSelectionPage();
                } else if (getConfig().products.length === 1) {
                    getConfig().selectedProduct = getConfig().products[0];
                    renderChooseProductButton();
                } else {
                    //there are no products... maybe show smth nicer.
                    triggerError(["No products active for this resource"]);
                }

                return response;
            })
            .catch(function (response) {
                utils.doCallback("timumFetchProductsFailed", getConfig(), response);

                if(response.response.status === 404){
                    triggerError("Unable to fetch products. Please make sure the resourceId you specified is correct.");
                } else {
                    triggerError(["Unable to fetch products.", response]);
                }
            });
    };

    var showProductSelectionPage = function () {
        utils.doCallback("showProductSelectiongPage", getConfig());

        var template = require(".././templates/product-selection/product-selection-page.html");

        productSelectionTarget = $(
            template.render({
                productSelectionHeadline: getConfig().ui.localization.product_selection_headline
            })
        );

        var productButtonContainer = productSelectionTarget.find(".bookingjs-productspage-products");
        $(productButtonContainer).append(renderProductButtons());

        rootTarget.append(productSelectionTarget);

        setTimeout(function () {
            calcProductSelectionFormHeight();
            productSelectionTarget.addClass("show");
        }, 100);
    };

    var hideProductSelectionPage = function () {
        utils.doCallback("closeProductSelectionPage", getConfig());

        productSelectionTarget.removeClass("show");

        setTimeout(function () {
            productSelectionTarget.remove();
        }, 200);
    };

    var renderProductButtons = function () {
        var buttonTemplate = require(".././templates/product-selection/selection-button.html");

        var buttons = [];
        $.each(getConfig().products, function (index, product) {
            var button = $(
                buttonTemplate.render({
                    productUuid: product.uuid,
                    productName: product.name,
                    productDuration: product.duration
                })
            );

            button.on("click", onSelectionButtonClick);
            buttons.push(button);
        });

        return buttons;
    };

    var renderChooseProductButton = function () {
        if (!getConfig().selectedProduct) {
            console.log("no product selected. Aborting.");
            return;
        }

        var buttonTemplate = require(".././templates/product-selection/open-page-button.html");

        var button = $(
            buttonTemplate.render({
                productName: getConfig().selectedProduct.name
            })
        );

        button.on("click", function (e) {
            e.preventDefault();
            showProductSelectionPage();
        });

        var calendarHeaderLeft = $(".fc-left");

        if ($(".bookingjs-productpage-open")) {
            $(".bookingjs-productpage-open").remove();
        }

        calendarHeaderLeft.append(button);

        return button;
    };

    var onSelectionButtonClick = function (e) {
        e.preventDefault();
        var button = $(this);
        var allButtons = $(".button");
        allButtons.removeClass("button--selected");
        button.addClass("button--selected");
        var productUuid = button.attr("data-uuid");

        $.each(getConfig().products, function (index, product) {
            if (product.uuid === productUuid) {
                getConfig().selectedProduct = product;
                console.log("Selected: " + getConfig().selectedProduct.name);
            }
        });
        renderChooseProductButton(); // removes the old button; adds new button with new values
        renderCalendarEvents(filterEventData(getConfig().unfilteredEvents));
        hideProductSelectionPage();
    };

    var setRootTarget = function (target) {
        rootTarget = target;
    };

    var setRequiredFunctions = function (renderEvents, error) {
        triggerError = error;
        renderCalendarEvents = renderEvents;
    };


    var calcProductSelectionFormHeight = function () {
        var headerHeight = $(".bookingjs-productspage-header").outerHeight(true);
        var form = $(".bookingjs-form");
        var dialogContainer = $(".bookingjs-productspage");
        var dialogHeight = dialogContainer.height();
        var footerHeight = $(".bookingjs-footer").outerHeight(true);
        var productsContainer = $(".bookingjs-productspage-products");
        var button = $(".button");

        var containerPaddingV = utils.getPaddingVertical(productsContainer);
        var containerPaddingH = utils.getPaddingHorizontal(productsContainer);
        var buttonPadding = utils.getPaddingHorizontal(button);

        form.height(dialogHeight - (headerHeight + footerHeight + containerPaddingV));
        productsContainer.height(dialogHeight - (headerHeight + footerHeight + containerPaddingV));
    };

    // ensures that only timeslots are displayed which match the chosen product
    var filterEventData = function (eventData) {
        var filteredEvents = [];

        if(eventData){
            $.each(eventData, function (index, event) {
                if (event.kind === "models.LotAppointment" && event.product_uuid === getConfig().selectedProduct.uuid) {
                    filteredEvents.push(event);
                } else if (event.kind === "models.Bookable") {
                    filteredEvents.push(event);
                }
            });
        }

        return filteredEvents;
    };

    return {
        timumFetchProducts: timumFetchProducts,
        showProductSelectionPage: showProductSelectionPage,
        renderChooseProductButton: renderChooseProductButton,
        filterEventData: filterEventData,
        setRootTarget: setRootTarget,
        setRequiredFunctions: setRequiredFunctions
    };
}

module.exports = ProductSelectionRenderHelper;
